/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import PageTitle from "../../components/common/PageTitle/PageTitle";
import {Button} from "antd";
import apiClient from "../../api/apiClient";
import {useStore} from "zustand";
import {useMessageStore} from "../../stores/messageStore";

const SystemSubscriptionAck = () => {
	const { setMessages } = useStore(useMessageStore);

	const onClick = async () => {
		try {
			const response = await apiClient.get(`${process.env.REACT_APP_API_URL}/api/admin/common/subscription/ack`);
			console.log('data', response.data);
			if (response.data.success) {
				setMessages('success', '완료');
			}
		} catch (e) {
			console.log('subscriptionAckAPI error:');
			console.error(e);
		}
	}

	return (
		<div>
			<div>
				<PageTitle title="구독 Ack 처리 실행"/>
			</div>

			<div>
				<Button onClick={onClick}>실행</Button>
			</div>
		</div>
	);
};

export default SystemSubscriptionAck;
